<template>
    <div class="container sticky-top z-2">
        <div v-if="is_client_seller" class="info-banner seller-banner d-flex justify-content-center gap-2">
            <img src="/img/icons/forbidden.svg" alt="img-forbidden">
            <p class="text-bat fs-7 text-left text-md-start">
                Conecta2 Contigo es una herramienta de trabajo. Material de comunicación de uso interno y dirigido a la fuerza de ventas de BAT.
            </p>
        </div>
        <div v-else class="info-banner d-flex justify-content-center gap-2">
            <img src="/img/icons/forbidden.svg" alt="img-forbidden">
            <p class="text-bat fs-7 text-left text-md-start">
                Material dirigido al canal de comercialización. Prohibida su reproducción total o parcial.
            </p>
        </div>
    </div>
</template>

<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
export default {
    components: { Slick },
    props: {
        location: {
            default: 'home',
        },
        is_client_seller: {
            default: false,
        },
    },
}
</script>
